type NetworkStatusMessageMap = {
  OFFLINE: string;
  UNREACHABLE: string;
  ONLINE: string;
  CONNECTING: string;
  [networkStatus: string]: string | undefined;
};

const NetworkStatusMessages: NetworkStatusMessageMap = {
  OFFLINE: 'No internet connection',
  UNREACHABLE: 'No connection',
  ONLINE: 'Connected',
  CONNECTING: 'Connecting...',
};

export default NetworkStatusMessages;
